<template>
    <div>
        <v-dialog v-model="dialog" persistent max-width="700px">  
            <v-card class="elevation-10">
            <v-toolbar >
                <!-- <v-toolbar-side-icon></v-toolbar-side-icon> -->
                <v-card-title><h3>Modificar datos laborales</h3></v-card-title>
            </v-toolbar>
            <v-card-title>
            <v-container grid-list-md text-xs-center>
                <v-layout row wrap>
                    <v-flex xs12 sm6 md12>
                        <v-text-field
                        v-model="correoOficial"
                        label="Correo oficial"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm4 md4>
                        <v-text-field
                        v-model="telefono"
                        label="Teléfono"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm8 md8>
                        <v-text-field
                        v-model="ubicacion"
                        label="Ubicación"
                        ></v-text-field>
                    </v-flex>
                
                </v-layout>
            </v-container>
            </v-card-title>
            <v-card-actions>
            <v-btn small color="primary" @click="guardar()">Agregar</v-btn>
            <v-btn small color="normal" @click="$emit('cerrar')">Cancelar</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from 'axios'
import moment from 'moment'

import { validationMixin } from 'vuelidate'
import { required, minLength, email } from 'vuelidate/lib/validators'
export default {
    name: 'ModificaLaboral',
    mixins: [validationMixin],
    props:['id','dialog','laboral'],
    computed: {
      ...mapGetters([
          "sessionToken",
          "httpURL",
          "userId"
      ]),
    },
    data() {
        return {
            correoOficial: null,
            telefono: null,
            ubicacion: null
        }
    },
    created(){
        this.correoOficial = this.laboral.correoOficial;
        this.telefono = this.laboral.telefono;
        this.ubicacion = this.laboral.ubicacion;
    },
    methods:{
      guardar(){
        // this.$v.$touch();
        // if( !this.$v.$invalid ){
        this.$emit('enviandoStart');
        axios.put(this.httpURL+'/personal/modificar/laboral',
        { 
            id: this.id,
            correoOficial: this.correoOficial,
            telefono: this.telefono,
            ubicacion: this.ubicacion,
        },
        {headers:{token: this.sessionToken}})
        .then(res => {
            // console.log(res);
            this.$emit('enviandoStop');
            this.$emit('laboralModificado',res.data.laboral);
            this.$emit('cerrar');
            this.$notify({ group: 'foo_notif', type:'success', duration:3500, text: res.data.mensaje});
        })
        .catch(error => {
            // console.log(error);
            this.$emit('enviandoStop');
            this.$notify({ group: 'foo_notif', type:'error', duration:4000, text: error.response.data.mensaje});
        });
        // }
      }
    }
}
</script>